"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "GenericMysqlFieldHandler", {
    enumerable: true,
    get: function() {
        return GenericMysqlFieldHandler;
    }
});
const _generic = require("~/db/field-handler/handlers/generic");
let GenericMysqlFieldHandler = class GenericMysqlFieldHandler extends _generic.GenericFieldHandler {
    // region filter comparisons
    async innerFilterAllAnyOf(args, rootArgs, _options) {
        const { val, sourceField } = args;
        const { filter, knex, column } = rootArgs;
        // Condition for filter, without negation
        const condition = (builder)=>{
            var _ref;
            var _column_dt;
            let items = (_ref = val == null ? void 0 : val.split(',')) != null ? _ref : [];
            if ([
                'enum',
                'set'
            ].includes((_column_dt = column.dt) == null ? void 0 : _column_dt.toLowerCase())) {
                items = items.map((item)=>item.trimEnd());
            }
            for(let i = 0; i < (items == null ? void 0 : items.length); i++){
                const bindings = [
                    sourceField,
                    `%,${items[i]},%`,
                    sourceField,
                    `%, ${items[i]},%`
                ];
                const sql = "(CONCAT(',', ??, ',') like ? OR CONCAT(',', ??, ',') like ?)";
                if (i === 0) {
                    builder = builder.where(knex.raw(sql, bindings));
                } else {
                    if (filter.comparison_op === 'allof' || filter.comparison_op === 'nallof') {
                        builder = builder.andWhere(knex.raw(sql, bindings));
                    } else {
                        builder = builder.orWhere(knex.raw(sql, bindings));
                    }
                }
            }
        };
        return {
            rootApply: undefined,
            clause: (qb)=>{
                if (filter.comparison_op === 'allof' || filter.comparison_op === 'anyof') {
                    qb.where(condition);
                } else {
                    qb.whereNot(condition).orWhereNull(sourceField);
                }
            }
        };
    }
};
